<div class="wcl-addon-dialog">
  <h2 mat-dialog-title>Add-On: {{ data.addOn.descriptionEN }}</h2>

  <button class="close-button" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>

  <mat-dialog-content>
    <ag-grid-angular
      [gridOptions]="gridOptions"
      class="ag-theme-cdx"
    ></ag-grid-angular>
  </mat-dialog-content>
</div>
